<template>
  <DialogTemplate
    :desktopFullscreen="true"
    contentStyle="overflow:hidden"
  >
    <EquityChartComplex
      class="flex-1"
      style="--clr-tick-back: var(--clr-black-1); padding: 0.5rem 0.25rem 0.25rem 0.25rem"
      :skeleton="false"
      :hands="l_sol_dynamic.combos"
      :hero="l_sol_static.hero"
      :opponent="l_sol_static.opponent"
      :rangeKey="$store.getters.sol_view_viewProps.rangeKey"
      :player="$store.getters.sol_view_viewProps.player"
      :handsHero="$store.getters.sol_filter_playersHandsIds[0]"
      :handsOpponent="$store.getters.sol_filter_playersHandsIds[1]"
      :handsActiveHero="
        $store.getters.sol_detail_tableMouseover || heroDetail.group_id ? heroDetail.hands_ids : []
      "
      :handsActiveOpponent="
        $store.getters.sol_detail_tableMouseover || opponentDetail.group_id
          ? opponentDetail.hands_ids
          : []
      "
      :hasFullscreen="false"
      tstPrefix="dialog_"
    >
      <!-- :handsPinnedHero -->
      <!-- :handsPinnedHero=""
:handsPinnedOpponent="" -->
    </EquityChartComplex>
    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        @click="close"
      >
        {{ $t('btn.close') }}
      </v-btn>
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import EquityChartComplex from '@/components/Charts/LineCharts/EquityChartComplex'

export default {
  name: 'ChartDialog',
  components: {
    EquityChartComplex,
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
  methods: {
    close() {
      this.$store.dispatch('router_rm_dialog', 'chart-eq-dialog')
    },
  },
  computed: {
    namespace() {
      return this.dialog.namespace || ''
    },
    l_sol_dynamic() {
      const res = {
        combos: this.$store.getters.sol_data_combos(),
      }
      return this.$store.getters.sol_data_updated && this.$store.getters.sol_filter_active
        ? res
        : res
    },
    heroDetail() {
      return this.$store.getters.sol_detail_players[0]
    },
    opponentDetail() {
      return this.$store.getters.sol_detail_players[1]
    },
    l_sol_static() {
      const res = {
        // TODO rm after 3way rls
        hero: this.$store.getters.sol_data_players()[0],
        opponent: this.$store.getters.sol_data_players()[1],
      }
      return this.$store.getters.sol_data_updated ? res : res
    },
  },
}
</script>
